import { useQuery } from '@tanstack/react-query';

import { PERMISSION } from 'src/features/auth';
import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

type QueryFnType = typeof queryFn;

const RESOURCE = '/user-permissions/';

const queryFn = (parking: string): Promise<PERMISSION[]> => {
    return axios.get(formatResourcePath(RESOURCE), { params: { parking } });
};

interface UseQueryHookOptions {
    config?: QueryConfig<QueryFnType>;
    parking: string;
}

const useQueryHook = ({ config, parking }: UseQueryHookOptions) => {
    return useQuery({
        queryKey: [RESOURCE, parking],
        queryFn: async () => await queryFn(parking),
        ...config,
    });
};

export { useQueryHook as useGetPermissions, RESOURCE as GET_PERMISSIONS_RESOURCE };
